module.exports = __webpack_public_path__ + "img/icon-livecasino-black.0eadd546.svg";